$.fn.TableOfContents = function(options) {
  let self = this

  if (self.data('table-of-contents')) {
    return self.data('table-of-contents')
  }

  self.options = $.extend(true, {
    link_selector: 'a',
    active_class: 'active',
    active_class_parent: true,
    header_offset: 32,
    scroller: $('html, body'),
    scroll_events: $.mlmi.scroller ? $.mlmi.scroller : $(window).ScrollEvents(),
    scrollto_speed: 450,
    scrollto_divider: 5,
    screen_percent: function() {
      return $(window).height() / 2
    },
  }, options)

  self.links = undefined
  self.current_element = undefined
  self.current_link = undefined
  self.current_y = undefined

  self.link_clicked = function(e) {
    e.preventDefault()
    if ($(this).data('target')) {
      let targetTop = $(this).data('target').offset().top
      if (typeof self.options.header_offset === 'function') {
        targetTop -= self.options.header_offset()
      } else {
        targetTop -= self.options.header_offset
      }
      self.options.scroller.scrollTo(targetTop, self.options.scrollto_speed, self.options.scrollto_divider, 'easeInOutQuart')
    }
  }

  self.page_scrolled = function(top) {
    /* reset current */
    self.current_y = undefined
    self.current_link = undefined
    self.current_element = undefined
    $('.' + self.options.active_class).removeClass(self.options.active_class)
    self.links.each(function() {
      let targetLink = $(this),
      targetElement = targetLink.data('target')
      if (targetElement.length) {
        let targetY = targetElement.offset().top - top - self.options.screen_percent()
        if (self.current_y == undefined || (targetY < 0 && targetY > self.current_y)) {
          self.current_element = targetElement
          self.current_link = targetLink
          self.current_y = targetY
        }
      }
    });
    if (!self.current_link) return
    if (self.options.active_class_parent) {
      self.current_link.parent().addClass(self.options.active_class)
    } else {
      self.current_link.addClass(self.options.active_class)
    }
  }

  self.initialize_links = function() {
    self.links = self.find(self.options.link_selector)
    self.links.each(function() {
      let link = $(this),
      hash = link.attr('href'),
      plainHash = hash.substring(1),
      targetElement = $(hash)
      if (!targetElement.length) {
        targetElement = $('a[name="' + plainHash + '"]')
      }
      if (targetElement.length) {
        link.data('target', targetElement)
      }
      $(this).on('click', self.link_clicked)
    })
  }

  return function() {
    self.initialize_links()
    self.options.scroll_events.add(self.page_scrolled)
    self.data('table-of-contents', self)
    return self
  }()
}
